var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipmentdetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3714_178267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.857117V7.71426M0.857117 7.71426H23.1428V21.4285C23.1428 21.8832 22.9622 22.3192 22.6407 22.6407C22.3192 22.9622 21.8832 23.1428 21.4285 23.1428H2.5714C2.11675 23.1428 1.68071 22.9622 1.35922 22.6407C1.03773 22.3192 0.857117 21.8832 0.857117 21.4285V7.71426Z",
    stroke: "black",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.857117 7.71426L3.42855 2.75997C3.70576 2.20158 4.12998 1.72934 4.65556 1.39406C5.18114 1.05877 5.78819 0.873135 6.4114 0.857117H17.5885C18.2264 0.857455 18.8515 1.03572 19.3936 1.37188C19.9357 1.70804 20.3733 2.18875 20.6571 2.75997L23.1428 7.71426M16.2823 12L11.1463 18.8571L7.71769 16.2891",
    stroke: "black",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3714_178267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentdetails);
export default __webpack_public_path__ + "static/media/shipmentdetails.6c3bae14a4aff0148670fa255449d195.svg";
export { ForwardRef as ReactComponent };